import { reduce } from 'lodash'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { menuData } from '../sidebar/menuData'
import './style.css'
import ProfileMenu from '../topbar/ProfileMenu/ProfileMenu';

export const Breadcrumb: React.FC = () => {

    const [breadcrumb, setBreadcrumb] = useState<any>([])

    const location = useLocation()

    const getPath = (data, url, parents = []) => {
        let items = reduce(
            data,
            (result, entry) => {
                if (result.length) {
                    return result
                } else if (entry.url === url) {
                    return [entry].concat(parents)
                }
                return result
            },
            [],
        )
        return items.length > 0 ? items : []
    }

    const getBreadcrumb = (items) => {
        let url = location.pathname.substring(1)
        let [activeMenuItem, ...path] = getPath(items, url)
        if (activeMenuItem && path.length) {
            return path.reverse().map((item, index) => {
                if (index === path.length - 1) {
                    return (
                        <span key={item.key}>
                            <span className="breadcrumbBar__arrow text-muted" />
                            <span className="text-muted">{item.title}</span>
                            <span className="breadcrumbBar__arrow" />
                            <strong>{activeMenuItem.title}</strong>
                        </span>
                    )
                } else {
                    return (
                        <span key={item.key}>
                            <span className="breadcrumbBar__arrow text-muted" />
                            <span className="text-muted">{item.title}</span>
                        </span>
                    )
                }
            })
        } else {
            return [getMenuItem(url)]
        }
    }

    const getMenuItem = (path: string) => {
        let pathName: string = path.split('/')[0]
        if (path.includes('edit')) {
            return (
                <span key={'edit'}>
                    <span className="breadcrumbBar__arrow text-muted" />
                    <span className="text-muted">{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>Edit</strong>
                </span>
            )
        } else if (path.includes('create')) {
            return (
                <span key={'create'}>
                    <span className="breadcrumbBar__arrow text-muted" />
                    <span className="text-muted">{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>Create</strong>
                </span>
            )
        } else if (path.includes('view')) {
            return (
                <span key={'view'}>
                    <span className="breadcrumbBar__arrow text-muted" />
                    <span className="text-muted">{getItemName(pathName)}</span>
                    <span className="breadcrumbBar__arrow" />
                    <strong>View</strong>
                </span>
            )
        } else {
            return (
                <span key={'default'}>
                    <span className="breadcrumbBar__arrow" />
                    <strong>{getItemName(pathName)}</strong>
                </span>
            )
        }
    }

    const getItemName = (pathname: string) => {
        let menuName: string = ''
        menuData.map(item => {
            const { title, url } = item
            let childItems = item.children
            if (url.localeCompare(pathname) == 0) {
                menuName = title
            }
            if (childItems) {
                childItems.map(childItem => {
                    if (childItem.url.localeCompare(pathname) == 0) {
                        menuName = childItem.title
                    }
                })
            }
        })
        return menuName
    }

    useEffect(() => {
        setBreadcrumb(getBreadcrumb(menuData))
    }, [location])

    return (
        <div className="breadcrumbBar">
            <div className="breadcrumbBar__path" style={{display: 'inline-block'}} >
                <Link to={`/`} className="text-muted">
                    Home
                </Link>
                {breadcrumb}
            </div>
            <div style={{display: 'inline-block', position: 'absolute', top: 5, right: 10}} >
                <ProfileMenu />
            </div>
        </div>
    )
}
